import React, { PureComponent } from "react";
import { push } from "react-router-redux";
import classnames from "classnames";
import _ from "i18n";

import { TiArrowSortedDown } from "react-icons/ti";

import collaboratorApi from "../../services/CollaboratorServices";
import styles from "./CollaboratorSpace.local.scss";

class CollaboratorSpaceFilter extends PureComponent {
  //******************   Content Functions  **************//

  constructor(props) {
    super(props);

    this.state = {
      collaborators: [],
      loadingCollaborators: false,
      keyWord: ""
    };
  }

  componentDidMount() {
    document.addEventListener(
      "mousedown",
      this.handleClickOutsideYearSelect.bind(this)
    );
    document.addEventListener(
      "mousedown",
      this.handleClickOutsideCollaboratorSelect.bind(this)
    );
    this.fetchCollaboratorsData(null);
  }

  fetchCollaboratorsData = keyWord => {
    const { organization } = this.props;
    this.setState({ loadingCollaborators: true });
    collaboratorApi
      .getCollaborators(organization.uen, keyWord)
      .then(resp => {
        this.setState({
          collaborators: resp.data.data,
          loadingCollaborators: false
        });
      })
      .catch(error => {
        this.setState({ error: true, loadingCollaborators: false });
      });
  };

  setYearWrapperRef(node) {
    this.yearWrapperRef = node;
  }

  handleClickOutsideYearSelect(event) {
    if (this.yearWrapperRef && !this.yearWrapperRef.contains(event.target)) {
      this.setState({ yearsSelectIsVisible: false });
    }
  }
  handleDisplayYearSelectItems = () => {
    this.setState(state => {
      return {
        yearsSelectIsVisible: !state.yearsSelectIsVisible
      };
    });
  };

  setCollaboratorWrapperRef(node) {
    this.collaboratorWrapperRef = node;
  }

  handleClickOutsideCollaboratorSelect(event) {
    if (
      this.collaboratorWrapperRef &&
      !this.collaboratorWrapperRef.contains(event.target)
    ) {
      this.setState({ collaboratorsSelectIsVisible: false });
    }
  }
  handleDisplayCollaboratorSelectItems = () => {
    this.setState(state => {
      return {
        collaboratorsSelectIsVisible: !state.collaboratorsSelectIsVisible
      };
    });
  };

  handleSearcheByKeyWord = event => {
    let value = event.target.value;
    this.setState({ keyWord: value });
    if (value.length > 2 || value.length === 0) {
      this.fetchCollaboratorsData(value);
    }
  };

  renderSelectPeriodFilter = () => {
    let {
      keyWord,
      collaborators,
      loadingCollaborators,
      yearsSelectIsVisible,
      collaboratorsSelectIsVisible
    } = this.state;
    const { loggedAs, spaceAs } = this.props;
    const params = new Map(
      window.location.search
        .slice(1)
        .split("&")
        .map(kv => kv.split("="))
    );
    return (
      <div style={{ display: "flex" }}>
        {loggedAs === "MANAGER" &&
          spaceAs === "MANAGER" && (
            <div
              ref={this.setCollaboratorWrapperRef.bind(this)}
              className={
                styles.customed_select +
                " " +
                (collaboratorsSelectIsVisible
                  ? styles.customed_select_opened
                  : "")
              }
              style={{ width: 230, marginLeft: 5 }}
            >
              <div className={styles.customed_select_header}>
                <span>{this.props.user.name}</span>
                <div className={styles.actions}>
                  <div>
                    <span
                      className={styles.action}
                      onClick={this.handleDisplayCollaboratorSelectItems}
                    >
                      <TiArrowSortedDown />
                    </span>
                  </div>
                </div>
              </div>
              {collaboratorsSelectIsVisible && (
                <div className={styles.customed_select_body}>
                  <div className={styles.customed_select_body_options}>
                    <div className={styles.customed_select_body_input}>
                      <input
                        value={keyWord ? keyWord : ""}
                        placeholder={`${_("search")} ...`}
                        onChange={event => this.handleSearcheByKeyWord(event)}
                      />
                    </div>
                    {loadingCollaborators && (
                      <div className={styles.ripple_loading_min}>
                        <img src={"/img/Ripple-1s-150px.svg"} alt="" />
                      </div>
                    )}
                    {!loadingCollaborators &&
                      collaborators.map((item, index) => (
                        <div
                          key={index}
                          className={styles.customed_select_body_option}
                          onClick={() => this.handleSelectCollaborator(item.id)}
                        >
                          {item.name}
                        </div>
                      ))}
                  </div>
                </div>
              )}
            </div>
          )}
        <div
          ref={this.setYearWrapperRef.bind(this)}
          className={
            styles.customed_select +
            " " +
            (yearsSelectIsVisible ? styles.customed_select_opened : "")
          }
          style={{ width: 90, marginLeft: 5 }}
        >
          <div className={styles.customed_select_header}>
            {/* <span>{this.props.year}</span>*/}
            <span>
              {params.has("year")
                ? params.get("year")
                : new Date().getFullYear()}
            </span>
            <div className={styles.actions}>
              <div>
                <span
                  className={styles.action}
                  onClick={this.handleDisplayYearSelectItems}
                >
                  <TiArrowSortedDown />
                </span>
              </div>
            </div>
          </div>
          {yearsSelectIsVisible && (
            <div
              className={classnames(
                styles.customed_select_body,
                styles.customed_select_body_min
              )}
            >
              <div className={styles.customed_select_body_options}>
                {["2019", "2020", "2021", "2022"].map((item, index) => (
                  <div
                    key={index}
                    className={styles.customed_select_body_option}
                    onClick={() => this.handleSelectYear(item)}
                  >
                    {item}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  handleSelectYear = year => {
    this.props.onChangeFilter(year);
    this.setState({ yearsSelectIsVisible: false });

    /* const urlParams = new URLSearchParams(window.location.search);
    urlParams.set("year", year);
    window.location.search = urlParams;*/
    //alert(JSON.stringify(window.location));
    const url = new URL(window.location);
    url.searchParams.set("year", year);
    window.history.pushState({}, "", url);
  };

  handleSelectCollaborator = id => {
    this.props.dispatch(push(`/collaborator-space/${id}`));
  };

  render() {
    return (
      <div className={styles.filter_block}>
        <div className={styles.title}>{_("dashboard")}</div>
        {this.renderSelectPeriodFilter()}
      </div>
    );
  }
}

export default CollaboratorSpaceFilter;



// WEBPACK FOOTER //
// ./src/components/CollaboratorSpace/CollaboratorSpaceFilter.js